import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/Login/LoginPage';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import SSOCallback from './components/SSOCallback';
import { isAuthenticated, syncSessionFromServer } from './auth-utils';

export const App = () => {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());
  const [initializing, setInitializing] = useState(!authenticated);

  useEffect(() => {
    if (authenticated) {
      setInitializing(false);
      return;
    }

    let active = true;
    syncSessionFromServer()
      .then((hasSession) => {
        if (!active) {
          return;
        }
        setAuthenticated(hasSession);
      })
      .finally(() => {
        if (active) {
          setInitializing(false);
        }
      });

    return () => {
      active = false;
    };
  }, [authenticated]);

  if (initializing) {
    return null;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            authenticated ? (
              <Navigate to="/apps" replace />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route path="/sso-callback" element={<SSOCallback />} />
        <Route
          path="/apps"
          element={
            authenticated ? (
              <DashboardPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/"
          element={
            <Navigate to={authenticated ? '/apps' : '/login'} replace />
          }
        />
      </Routes>
    </Router>
  );
};
